var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { LoginBaseModel } from './login-base-model';
var BiodigitalLoginModel = /** @class */ (function (_super) {
    __extends(BiodigitalLoginModel, _super);
    function BiodigitalLoginModel(email, password, rememberMe) {
        var _this = _super.call(this) || this;
        _this.email = email;
        _this.password = password;
        _this.rememberMe = rememberMe;
        return _this;
    }
    BiodigitalLoginModel.toJSON = function (value) {
        return {
            id_token: value.token,
            version: value.version,
            group_invite_mode: value.groupInviteMode,
            group_invite_key: value.groupInviteKey,
            group_code_mode: value.groupCodeMode,
            group_code: value.groupCode,
            email: value.email,
            password: value.password,
            email_remember_me: value.rememberMe
        };
    };
    return BiodigitalLoginModel;
}(LoginBaseModel));
export { BiodigitalLoginModel };
